import { IAnaliseLaboratorial } from "@/interfaces/IAnaliseLaboratorial";
import { createAction } from "@reduxjs/toolkit";

const add = createAction(
  "REQUISICAO_ANALISE_LABORATORIAL/add",
  (item: IAnaliseLaboratorial) => ({
    payload: { item },
  })
);

const remove = createAction(
  "REQUISICAO_ANALISE_LABORATORIAL/remove",
  (offlineId: number) => ({
    payload: { offlineId },
  })
);

const update = createAction(
  "REQUISICAO_ANALISE_LABORATORIAL/update",
  (item: IAnaliseLaboratorial) => ({
    payload: { item },
  })
);

export const requisicaoAnaliseLaboratorialAction = {
  add,
  remove,
  update,
};
